import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  DeeplinkNavigationServiceRequest,
  DeeplinkNavigationServiceResponse,
} from './deeplink-navigation.dto';
import {
  DeeplinkNavigationServiceRequestDtoSchema,
  DeeplinkNavigationServiceResponseDtoSchema,
} from './deeplink-navigation.dto';

export const create29cmUrls = (url: string) => {
  const webUrl = url;
  const deeplinkUrl = `app29cm://web/${webUrl}`;

  return { webUrl, deeplinkUrl };
};

export const deeplinkNavigationService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(DeeplinkNavigationServiceRequestDtoSchema),
    (request: DeeplinkNavigationServiceRequest): Promise<DeeplinkNavigationServiceResponse> => {
      const { url } = request;

      // URL 생성
      const { webUrl, deeplinkUrl } = create29cmUrls(url);

      return Promise.resolve({ webUrl, deeplinkUrl });
    },

    validateServiceResponse(DeeplinkNavigationServiceResponseDtoSchema),
  ),
);
